'use client';

import posthog from 'posthog-js';

import {
  promotionKey,
  readPromotionValue,
  writePromotionValue
} from '@/lib/presentation-promotion';

export function isPresentationLandingUrl(value: unknown) {
  if (typeof value !== 'string') return false;
  try {
    return new URL(value).pathname.replace(/\/+$/, '') === '/home/ai-presentation-maker';
  } catch {
    return false;
  }
}

// Queued when the welcome opens (retried on close); displayed after other modals close.
// Attribution stays browser-local:
// no person lookup, flag request, or change to PostHog's tracking properties.
export function queueSignupPresentationPromotion(userId: string) {
  const key = promotionKey(userId, 'signup-landing');
  if (!userId || readPromotionValue(key)) return;
  try {
    if (!posthog.__loaded) return;
    // Marketing and chat can use separate instances backed by the same persistence.
    posthog.persistence?.load();
    const initialUrl = posthog.persistence?.get_initial_props?.()?.$initial_current_url;
    if (isPresentationLandingUrl(initialUrl)) writePromotionValue(key, 'pending');
  } catch {
    // Missing/blocked attribution must never delay onboarding.
  }
}
